import { AppTheme } from "./theme.model";
import { DefaultThemePreset } from "./default-theme";
import { CartierThemePreset } from "./cartier-theme";
import { CulturespacesThemePreset } from "./culturespaces-theme";

export const AVAILABLE_THEMES: AppTheme[] = [
  {
    name: "default",
    hosts: ["localhost"],
    preset: DefaultThemePreset,
  },
  {
    name: "cartier",
    hosts: [
      "fc-dev.guestup.com",
      "fc-test.guestup.com",
      "event-fondationcartier.guestup.com",
    ],
    preset: CartierThemePreset,
  },
  {
    name: "culturespaces",
    hosts: [
      "museum-dev.guestup.com",
      "museum-test.guestup.com",
      "event-culturespaces.guestup.com",
    ],
    preset: CulturespacesThemePreset,
  },
];
